import { Bound } from '@/models/GenerateCondit';
import { Aggregator, CALCWEIGHT } from '@/models/GenerateCondit/Interrelated';

export default params => {
  let originSite = null,
    destinaSite = null;
  if (params['originCenter']) {
    originSite = { key: 'originCenter', value: params['originCenter'] };
  } else if (params['originProvinceArea']) {
    originSite = { key: 'originProvinceArea', value: params['originProvinceArea'] };
  }

  if (params['destinationCenter']) {
    destinaSite = { key: 'destinationCenter', value: params['destinationCenter'] };
  } else if (params['destinationProvinceArea']) {
    destinaSite = { key: 'destinationProvinceArea', value: params['destinationProvinceArea'] };
  }

  const pubFilter = {
    simpleGranularity: 'all',
    dataSource: 't_actual_load_unload_day_nine',
    dimensions: [
      'originCenter',
      'destinationCenter',
      'originProvinceArea',
      'destinationProvinceArea',
    ],
    startDate: params.startDate,
    endDate: params.endDate,
    aggregators: [CALCWEIGHT],
    // limit: 100,
    andFilters: [{ key: 'scanType', value: '录单' }],
  };

  if (originSite) {
    pubFilter.andFilters.push(originSite);
  }
  if (destinaSite) {
    pubFilter.andFilters.push(destinaSite);
  }

  return [
    {
      remake: '全部数据',
      ...pubFilter,
      dimensions: [...pubFilter.dimensions],
      aggregators: [
        new Aggregator('doubleSum', 'calcWeight', 'calcWeight'),
        new Aggregator('longSum', 'ticket', 'ticket'),
      ],
    },
    {
      remake: '产品时效',
      ...pubFilter,
      dimensions: [...pubFilter.dimensions, 'lengthOfTime'],
    },
    {
      remake: '产品类型',
      ...pubFilter,
      dimensions: [...pubFilter.dimensions, 'productType'],
      // inFilters: [{ key: 'productType', value: ['MINI电商小件', 'MINI电商大件'] }],
    },
    // {
    //   ...pubFilter,
    //   dimensions: [...pubFilter.dimensions, 'productType'],
    //   inFilters: [{ key: 'productType', value: ['普惠达', '精准零担', '安心达', '定时达'] }],
    // },
    // {
    //   remake: '800kg+',
    //   ...pubFilter,
    //   dimensions: [...pubFilter.dimensions, 'waybillNo'],
    //   aggregators: [new Aggregator('doubleSum', 'calcWeight', 'totalCalcWeight')],
    //   boundFilters: [new Bound('totalCalcWeight', '800')],
    // },
    {
      remake: '网络',
      ...pubFilter,
      dimensions: [...pubFilter.dimensions],
      andFilters: [...pubFilter.andFilters, { key: 'goodsType', value: '网络' }],
    },
    // {
    //   remake: 'longSumAll',
    //   ...pubFilter,
    //   // dimensions: [...pubFilter.dimensions, 'waybillNo'],
    //   dimensions: [...pubFilter.dimensions],
    //   aggregators: [
    //     // new Aggregator('doubleSum', 'calcWeight', 'calcWeight'),
    //     new Aggregator('longSum', 'ticket', 'ticket'),
    //   ],
    // },
    // {
    //   remake: '<=300kg',
    //   ...pubFilter,
    //   dimensions: [...pubFilter.dimensions, 'waybillNo'],
    //   // dimensions: [...pubFilter.dimensions],
    //   boundFilters: [new Bound('calcWeight', '0', '300', false, true)],

    //   // remake: '全部数据',
    //   // ...pubFilter,
    //   // dimensions: [...pubFilter.dimensions],
    // },
    {
      remake: '>300kg',
      ...pubFilter,
      dimensions: [...pubFilter.dimensions, 'waybillNo'],
      // dimensions: [...pubFilter.dimensions],
      aggregators: [
        new Aggregator('doubleSum', 'calcWeight', 'calcWeight'),
        new Aggregator('longSum', 'ticket', 'ticket'),
      ],
      boundFilters: [new Bound('calcWeight', '300')],
    },
    // {
    //   remake: '填仓',
    //   ...pubFilter,
    //   dimensions: [...pubFilter.dimensions],
    //   likeFilters: [{ key: 'originSite', value: '^*T' }],
    // },
  ];
};
